import React, {Component} from "react"
import {Container} from './styled'

class CardAdd extends Component {
    render() {
        const {children, ...props} = this.props
        return (
            <Container justify="center" flow="column" {...props}>
                {children}
            </Container>
        )
    }
}

export default CardAdd